<script setup>
import {computed, ref} from 'vue'
import vFormValidation from '@/vue/directives/formValidation'
import FormControlPlainText from "@/common/form-control/FormControlPlainText.vue"
import {useFormStore} from '@/stores/form'

const props = defineProps({
    currentData: Object,
    field: Object,
    formId: String,
    value: String // Without this the field won't invalidate if the no. of decimals doesn't make the step.
})

// Instantiate dynamic Pinia Form Store
const formStore = useFormStore(props.formId)

// Reactive data
// Without a step which includes decimal places Safari will invalidate number fields containing decimals.
const step = ref(0.01)

// Computed properties
// Safari's validation message is completely meaningless, all it outputs is "Enter a valid value", so let's
// provide something a bit more helpful!
const title = computed(() => {
    const stepStr = step.value + '' // Convert float to string
    const numberOfDecimals = stepStr.indexOf('.') === -1
        ? 0
        : stepStr.split('.')[1].length

    return 'Please enter a valid value. The number requires ' + numberOfDecimals + ' decimal places.'
})

// Emulating the created hook logic
if (
    props.field.defaultValue &&
    // todo - Shouldn't setDefaultValue only ever be applied when an id is not set?
    //        This should be investigated and if so this condition moved inside the form module.
    !props.currentData.id
) {
    formStore.setDefaultValue({
        name: props.field.name,
        value: props.field.defaultValue
    })
}
</script>

<template>
    <FormControlPlainText v-if="field.readonly" :value="currentData[field.name] ? '£' + currentData[field.name] : ''"
                          :form-id="formId"/>
    <input v-else :id="field.id" v-model="currentData[field.name]" v-form-validation :max="field.max" :min="field.min"
           :name="field.name" :placeholder="field.placeholder || null" :required="field.required" :size="field.size"
           :step="field.step || step" :title="title" class="form-control" :class="{'is-invalid': field.error}"
           type="number">
</template>